module.exports = __webpack_public_path__ + "static/media/CancelIcon.de23c2c5.svg";